import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import { sortByPublishDate } from '../../tools/mappers';
import SmartLink from '../Common/SmartLink';
import BlogCard from './BlogCard';
import * as styles from './BlogCardSection.module.css';

const BlogCardSection = ({ header, headerSlug, posts = [], smallCards }) => {
  const amountToDisplay = smallCards ? 6 : 3;
  const cards = posts
    .sort(sortByPublishDate)
    .slice(0, amountToDisplay)
    .map((post, i) => {
      const gatsbyImageData = get(post, 'heroImage.gatsbyImageData');
      const img = get(post, 'heroImage.file.url');

      return (
        <BlogCard
          key={i}
          slug={get(post, 'slug', '')}
          img={img}
          gatsbyImageData={gatsbyImageData}
          title={get(post, 'title', '')}
          description={get(post, 'articleDescription.articleDescription', '')}
          author={get(post, 'author.name', '')}
          date={get(post, 'publishDate', '')}
          readTime={post.readTime}
          isSmall={smallCards}
          category={get(post, 'categories[0].categoryName')}
        />
      );
    });

  return (
    <div className={headerSlug ? styles.category : ''}>
      <nav className={styles.nav}>
        <h4>{header}</h4>
        {headerSlug && <SmartLink to={`/blog/${headerSlug}`}>View all</SmartLink>}
      </nav>
      <section className={smallCards ? styles.col2 : styles.col3}>{cards}</section>
    </div>
  );
};

BlogCardSection.defaultProps = {
  smallCards: false,
};

BlogCardSection.propTypes = {
  postContent: PropTypes.object,
  smallCards: PropTypes.bool,
};

export default BlogCardSection;
